const WORKER_SRC = `
let timer = null;
self.onmessage = (e) => {
  if (e.data === 'start') {
    if (timer) return;
    const interval = e.intervalMs || 16;
    timer = setInterval(() => self.postMessage(1), interval);
  } else if (e.data === 'stop') {
    if (timer) clearInterval(timer);
    timer = null;
  }
};
`;

let worker = null;
const subs = new Set();

const ensureWorker = () => {
  if (worker) return;
  const blob = new Blob([WORKER_SRC], { type: "application/javascript" });
  worker = new Worker(URL.createObjectURL(blob));
  worker.onmessage = () => {
    for (const fn of subs) {
      try {
        fn();
      } catch (err) {
        console.error("djTicker listener error:", err);
      }
    }
  };
};

export const subscribeTicker = (fn) => {
  ensureWorker();
  subs.add(fn);
  if (subs.size === 1) worker.postMessage("start");
  return () => {
    subs.delete(fn);
    if (subs.size === 0 && worker) worker.postMessage("stop");
  };
};
